<template>
    <form-row title="Is any Portion Refundable?" :no_border="true" class="mt-8">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="entitlement_additional_money_refundable"
                v-model="entitlement_additional_money_refundable"
                true="Yes"
                false="No"
                :read_only="read_only"
            />
        </div>

        <div v-if="entitlement_additional_money_refundable" class="flex mt-4 items-center">
            <div class="flex-none sm:w-36 my-2">
                <div v-show="entitlement_additional_money_refundable_by_percent">
                    <input-money
                        :value="entitlement_additional_money_refundable_by_percent"
                        tabindex="-1"
                        :read_only="true"
                    />
                </div>

                <div v-show="! entitlement_additional_money_refundable_by_percent">
                    <input-money
                        v-model="entitlement_additional_money_refundable_entered"
                        :read_only="read_only"
                    />
                </div>

                <input
                    name="entitlement_additional_money_refundable_amount"
                    type="hidden"
                    :value="entitlement_additional_money_refundable_amount"
                    :read_only="true"
                />
            </div>

            <div class="flex flex-1 items-center my-2">
                <span class="text-sm text-gray-600 sm:pl-6 pr-6">
                    {{ $t('- OR -') }}
                </span>

                <div class="w-1/4 sm:w-1/5">
                    <input-percent
                        name="entitlement_additional_money_refundable_percent"
                        v-model="entitlement_additional_money_refundable_percent"
                        :read_only="read_only"
                    />
                </div>

                <span class="text-sm text-gray-600 leading-snug pl-4">
                    {{ $t('of') }} {{ additional_money_formatted }} <br>{{ $t('additional money') }}
                </span>
            </div>
        </div>
    </form-row>
</template>

<script>
import MoneyFunctions from '../../../../mixins/money-functions.js';

export default {
    mixins: [
        MoneyFunctions,
    ],

    props: {
        commercial: { default: () => ({}) },
        read_only: { default: false },
        additional_money_amount: {},
    },

    data() {
        return {
            entitlement_additional_money_refundable: this.commercial.entitlement_additional_money_refundable,
            entitlement_additional_money_refundable_percent:
                this.commercial.entitlement_additional_money_refundable_percent,
            entitlement_additional_money_refundable_entered:
                this.commercial.entitlement_additional_money_refundable_amount,
        }
    },

    computed: {
        additional_money() {
            return this.formatMoney(this.additional_money_amount);
        },
        entitlement_additional_money_refundable_by_percent() {
            return this.entitlement_additional_money_refundable_percent
                ? this.formatMoney((this.entitlement_additional_money_refundable_percent / 100) * this.moneyVal(this.additional_money))
                : null;
        },
        entitlement_additional_money_refundable_amount() {
            return this.entitlement_additional_money_refundable_by_percent || this.entitlement_additional_money_refundable_entered;
        },
        additional_money_formatted() {
            return this.additional_money && ! isNaN(this.additional_money)
                ? '$' + this.formatMoneyToString(this.additional_money)
                : '';
        },
    },
}
</script>
